module.exports = __webpack_public_path__ + "static/team-77e8d41720be7457a5821a358918f821.jpg";